import { combineReducers } from 'redux';
import productsAdditionalInfo from '../shared/productsAdditionalInfo';
import personalInfo from '../../myaccount/reducers/personalInfo';
import mobileBottomNavReducer from './mobileBottomNavReducer';
import networkStatus from '../shared/networkStatus';
import webMetaData from '../shared/webMetaData';
import seoMetaData from '../shared/seoMetaData';
import navigation from '../shared/navigation';
import httpError from '../shared/HTTPError';
import location from '../shared/location';
import products from '../shared/products';
import request from '../shared/request';
import loaders from '../shared/loaders';
import search from '../shared/search';
import facets from '../shared/facets';
import modals from '../shared/modal';
import myaccount from '../myaccount';
import appticker from '../appticker';
import roadblock from '../roadblock';
import flags from '../shared/flags';
import popup from '../shared/Popup';
import sorts from '../shared/sorts';
import grid from '../shared/grid';
import RecentSearches from '../shared/recentSearch';
import bannerInfo from '../../myaccount/reducers/bannerInfo';
import counter from '../shared/counter';
import plpTopBannerReducer from '../plpTopBanner';
import plpExtendedBanner from '../plpExtendedBanner';
import banner from '../shared/banner';
import bannerProducts from '../bannerProducts';
import wishlist from '../../wishlist/reducers/wishlist';
import product from '../shared/product';
import jioAds from '../shared/jioAds';
import ratingsReducers from '../shared/ratings';
import ajioWalletDataBottomStrip from '../shared/ajioWalletDataBottomStrip';
import fleekRootReducer from '../../fleek/reducers/fleekRootReducer';
import membershipReducer from '../shared/membershipReducer';
import cacheData from '../shared/cacheData';
import addressBook from '../../myaccount/reducers/addressBook';
import ajioWalletData from '../../myaccount/reducers/ajioWalletData';
import { miscellaneousReducer } from '../shared/miscellaneous';
import { rushAddressBarFlagReducer, rushDeliveryTypeReducer } from '../shared/ajioRush';
import recommendationWidgetReducer from '../shared/recommendationWidget';
import variants from '../shared/variants';

const rootReducer = combineReducers({
  bottomNavList: mobileBottomNavReducer,
  plpTopBanner: plpTopBannerReducer,
  plpExtendedBanner,
  productsAdditionalInfo,
  metaData: webMetaData,
  RecentSearches,
  networkStatus,
  personalInfo,
  seoMetaData,
  navigation,
  appticker,
  roadblock,
  httpError,
  myaccount,
  location,
  products,
  request,
  loaders,
  search,
  facets,
  modals,
  grid,
  sorts,
  popup,
  flags,
  bannerInfo,
  counter,
  banner,
  bannerProducts,
  product,
  wishlist,
  jioAds,
  ratings: ratingsReducers,
  fleek: fleekRootReducer,
  cacheData,
  membership: membershipReducer,
  addressBook,
  miscellaneous: miscellaneousReducer,
  rushAddressBarFlagReducer,
  rushDeliveryTypeReducer,
  ajioWalletData,
  ajioWalletDataBottomStrip,
  widgets: recommendationWidgetReducer,
  variants
});

export default rootReducer;
